/**
 * Hand bytes to the browser as a file to save.
 *
 * Here rather than in a feature because it was about to be in three of them:
 * a CSV export in the connector, an invoice PDF in the ledger, an account
 * statement in the portal. All three need the same four lines, and the fourth
 * is the one a copy forgets.
 *
 * **The bytes are fetched, not linked.** These endpoints are behind a bearer
 * token, and an `<a href>` the browser follows carries no Authorization
 * header — it would download the sign-in page's HTML under the name of an
 * invoice. So the caller reads the blob with an authenticated request and
 * passes it here.
 *
 * **The object URL is revoked.** A URL pins its blob in memory until it is,
 * and a session that exported a 32 000-article catalogue a few times would
 * hold every copy. Revoking immediately after the click is safe: the browser
 * has already taken its own reference to the data by then.
 */

export function download(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
